

export const topicPastePlaceholder =
"Paste content or enter a topic to simplify";

export const uploadContentLinkLabel = "UPLOAD CONTENT (PDF, DOC, TXT)";

export const previewDocumentContent = [
  "Cell biology introduces students to organelles, membrane transport, and how structure relates to function. A teaching guide should connect microscope observations to labeled diagrams and everyday examples.",
  "Include a short activation question, a visual diagram walkthrough, and a quick check that asks students to explain why mitochondria are often called the powerhouse of the cell.",
];

export {
  familiarTopics,
  familiarTopicsHeading,
} from "../shared/familiarTopics";

export const targetFormatOptions = [
  { id: "teaching-guide", label: "Teaching Guide" },
  { id: "lesson-flow", label: "Lesson Flow" },
  { id: "simplified-explanation", label: "Simplified Explanation" },
  { id: "example-based-explanation", label: "Example-based Explanation" },
];


export const generateTeachingGuideLabel = "Generate Teaching Guide";

export const generateTeachingGuideHint =
"Creates a high-quality, structured pedagogical guide for your classroom";

export const defaultTeachThisTopicConfig = {
  selectedTopicId: "",
  selectedTopicLabel: "",
  topicText: "",
  pastedContent: "",
  targetFormat: "teaching-guide"
};

export const generatingTeachingGuideMessage = "Generating your teaching guide…";